<template>
    <Card class="card">
        <template #title>
            Help
            <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                style="position:fixed;right:10px" @click="close()" />
        </template>
        <template #content>
            <TabView v-model:activeIndex="activeIndex">
                <TabPanel>
                    <template #header>
                        <span>User Guide</span>
                    </template>
                    <ScrollPanel class="contentPanel">
                        <div class="t-a-left">
                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <i class="pi pi-folder-open pi-icon" style="font-size: 1.5rem"></i>
                                </div>
                                <p>Open project</p>
                            </div>
                            <ul>
                                <li>Create a new project</li>
                                <li>Open an existing project</li>
                                <li>Save an existing project as a copy</li>
                            </ul>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <i class="pi pi-pencil pi-icon" style="font-size: 1.5rem"></i>
                                </div>
                                <p>Edit current project details</p>
                            </div>

                            <ul>
                                <li>Add/import site boundaries on map</li>
                                <li>Add/import zone boundaries within the site</li>
                                <li>Add/edit construction schedule</li>
                            </ul>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <i class="pi pi-circle" style="font-size: 0.7rem; margin-top: 17px;"></i>
                                </div>
                                <p>(Optional) Edit center point for the site</p>
                            </div>
                            <ul>
                                <li>Change the center of the site on map</li>
                            </ul>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <img src="img/pme.png" class="image-icon" alt="PME" />
                                </div>
                                <p>Add/edit construction equipment</p>
                            </div>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <img src="img/Calculation.png" class="image-icon" alt="Calculation" />
                                </div>
                                <p>Noise calculation</p>
                            </div>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <i class="pi pi-building pi-icon" style="font-size: 1.5rem"></i>
                                </div>
                                <p>(Optional) Add concurrent sites</p>
                            </div>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <i class="pi pi-plus-circle pi-icon" style="font-size: 1.5rem"></i>
                                </div>
                                <p>Select NSRs to include in report</p>
                            </div>
                            <ul>
                                <li>Add, move, and delete NSR points on map</li>
                                <li>Selected NSR points will be included in the report</li>
                            </ul>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <img src="img/mitigation.png" class="image-icon" alt="Mitigation" />
                                </div>
                                <p>Add noise mitigations for equipment</p>
                            </div>

                            <div class="icon-with-label">
                                <div class="icon-container">
                                    <i class="pi pi-book pi-icon" style="font-size: 1.5rem"></i>
                                </div>
                                <p>Generate report: creates construction noise management plan</p>
                            </div>
                        </div>
                        <div>
                            For more information, please refer to following videos:
                            <ul>
                                <li><a :href="`/others/videos/registration.mp4`" target="_blank">Registration</a>
                                </li>
                                <li><a :href="`/others/videos/login and general info.mp4`" target="_blank">Login &
                                        General Info</a></li>
                                <li><a :href="`/others/videos/create new project.mp4`" target="_blank">Create
                                        New
                                        Project</a></li>
                                <li><a :href="`/others/videos/add equipment.mp4`" target="_blank">Add
                                        Equipment</a></li>
                                <li><a :href="`/others/videos/calculate noise and select nsr.mp4`"
                                        target="_blank">Calculate
                                        Noise & Select NSR</a></li>
                                <li><a :href="`/others/videos/mitigation.mp4`" target="_blank">Mitigation</a>
                                </li>
                                <li><a :href="`/others/videos/generate report.mp4`" target="_blank">Generate
                                        Report</a>
                                </li>
                            </ul>
                        </div>
                        <div style="height: 40px;">
                            If you have any views, suggestions, enquiries or complaints, you may contact us through
                            email
                            (web-CNMP@epd.gov.hk).
                        </div>
                    </ScrollPanel>
                </TabPanel>
            </TabView>
        </template>
    </Card>
</template>

<script>

export default {
    name: 'GuideView',
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
        close() {
            this.$router.replace({ path: '/' });
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.card {
    width: 50vw;
    position: absolute;
    transform: translate(60%, 10%);
}

.t-a-left {
    text-align: left;
}

.icon-container {
    background-color: #00632c;
    color: white;
    height: 3.5rem;
    width: 3.5rem;
    justify-content: center;
    display: flex;
}

.image-icon {
    width: 25px;
    padding: 0.5rem 0;
}

.pi-icon {
    margin-top: 10px;
}

.icon-with-label {
    display: flex;
    margin-bottom: 10px;
}

.icon-with-label p {
    margin-left: 10px;
}

.contentPanel {
    width: 100%;
    height: calc(100vh - 320px - 4rem);
    text-align: left;
}
</style>